import { searchParticipantsQuery, getParticipantQuery, searchSitesQuery, getSiteQuery } from '../graphql/queries';
import { MOCK_PARTICIPANTS, MOCK_SITES } from '../testing/store.testing';
import Fuse from 'fuse.js';
import { Participant, Site } from '../types/common.types';

const searchParticipants = (participants: Participant[], searchTerm: any) => {
  if (!searchTerm.trim()) {
    return participants;
  }

  const fuse = new Fuse<Participant>(participants, {
    keys: ['firstName', 'surname', 'participantRef', 'email', 'nhsNum', 'participantStatus'],
    threshold: 0.3,
    ignoreLocation: true,
  });

  return fuse.search(searchTerm).map((result) => result.item);
};

const searchSites = (sites: Site[], searchTerm: string) => {
  if (!searchTerm.trim()) {
    return sites;
  }

  const fuse = new Fuse<Site>(sites, {
    keys: ['name', 'code', 'address1', 'address2', 'postcode', 'provider'],
    threshold: 0.3,
    ignoreLocation: true,
  });

  return fuse.search(searchTerm).map((result) => result.item);
};

const renderData = (query: string, request: any) => {
  switch (query) {
    case searchParticipantsQuery:
      return {
        searchParticipants: {
          items: searchParticipants(MOCK_PARTICIPANTS, request.variables.keyword),
          nextToken: '12345',
        },
      };
    case getParticipantQuery:
      return {
        getParticipant: MOCK_PARTICIPANTS.filter((p) => p.participantId === request.variables.participantId).pop(),
      };
    case searchSitesQuery:
      return {
        searchSites: {
          items: searchSites(MOCK_SITES, request.variables.keyword),
          nextToken: '23456',
        },
      };
    case getSiteQuery:
      return {
        getSite: MOCK_SITES.filter((p) => p.code === request.variables.code).pop(),
      };
    default:
      return;
  }
};

interface GraphqlRequest {
  query: string;
  variables?: object;
}

export const API = {
  graphql: (request: GraphqlRequest) => {
    return new Promise((resolve, reject) => {
      setTimeout(function () {
        if (renderData(request.query, request)) {
          resolve({
            data: renderData(request.query, request),
          });
        } else {
          reject({
            errors: [{ message: 'No query or mutation set' }],
          });
        }
      }, 2000);
    });
  },
};
